import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["venueFields", "festivalFields"]

  toggle(event) {
    const value = event.target.value

    if (value === "venue") {
      this.venueFieldsTarget.classList.remove("hidden")
      this.festivalFieldsTarget.classList.add("hidden")
      // Clear edition when switching to venue
      this.clearEditionField()
    } else {
      this.venueFieldsTarget.classList.add("hidden")
      this.festivalFieldsTarget.classList.remove("hidden")
      // Clear venue when switching to festival
      this.clearVenueField()
    }
  }

  clearEditionField() {
    const editionSelect = this.festivalFieldsTarget.querySelector("select[name*='edition_id']")
    if (editionSelect) {
      editionSelect.value = ""
    }
  }

  clearVenueField() {
    const venueSelect = this.venueFieldsTarget.querySelector("select[name*='venue_id']")
    if (venueSelect) {
      venueSelect.value = ""
    }
    // Note: City field is kept as it's shared between venue and festival modes
  }

  disconnect() {
    // Cleanup if needed
  }
}
